import React from "react";

interface PlaceholderProps {
  title: string;
  description: string;
  className?: string; // Optional for custom styling
}

const EmptyPlaceholder: React.FC<PlaceholderProps> = ({
  title,
  description,
  className = "",
}) => {
  return (
    <div className={`text-center text-gray-600 mt-8 ${className}`}>
      <h2 className="text-xl font-bold mb-4">{title}</h2>
      <p>{description}</p>
    </div>
  );
};

export default EmptyPlaceholder;
